import api from "./api";

export const ESCUTA_TIPO_OPCOES = [
  { value: "OPINIAO", label: "Opinião" },
  { value: "SUGESTAO", label: "Sugestão" },
  { value: "RECLAMACAO", label: "Reclamação" },
  { value: "DUVIDA", label: "Dúvida" },
  { value: "ELOGIO", label: "Elogio" },
  { value: "DENUNCIA", label: "Denúncia" },
  { value: "ASSEDIO", label: "Assédio" },
  { value: "CONFLITO", label: "Conflito" },
  { value: "SOBRECARGA", label: "Sobrecarga de trabalho" },
  { value: "RISCO_SST", label: "Risco à saúde e segurança" },
  { value: "OUTRO", label: "Outro" },
] as const;

export const ESCUTA_STATUS_OPCOES = [
  { value: "RECEBIDA", label: "Recebida" },
  { value: "EM_ANALISE", label: "Em análise" },
  { value: "EM_APURACAO", label: "Em apuração" },
  { value: "AGUARDANDO_RETORNO", label: "Aguardando retorno" },
  { value: "CONCLUIDA", label: "Concluída" },
  { value: "ARQUIVADA", label: "Arquivada" },
] as const;

export interface EscutaPublica {
  protocolo: string;
  tipo: string;
  tipoLabel: string;
  assunto: string;
  relato: string;
  status: string;
  statusLabel: string;
  anonima: boolean;
  nome: string | null;
  createdAt: string;
  resposta: string | null;
  querRetorno: boolean;
}

export interface EscutaListaItem {
  id: string;
  protocolo: string;
  tipo: string;
  tipoLabel: string;
  assunto: string;
  anonima: boolean;
  nome: string | null;
  status: string;
  statusLabel: string;
  sensivel: boolean;
  querRetorno: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface EscutaDetalhe extends EscutaListaItem {
  relato: string;
  local: string | null;
  quando: string | null;
  envolve: string | null;
  setor: string | null;
  contato: string | null;
  responsavel: string | null;
  notasInternas: string | null;
  resposta: string | null;
}

export interface EscutaResumo {
  abertas: number;
  recebidas: number;
  emAnalise: number;
  aguardando: number;
  concluidasMes: number;
  anonimasMes: number;
}

export interface EscutaFormInput {
  tipo: string;
  assunto: string;
  relato: string;
  local: string;
  quando: string;
  envolve: string;
  identificar: boolean;
  nome: string;
  setor: string;
  contato: string;
  querRetorno: boolean;
}

export function extractEscutaError(e: unknown, fallback: string): string {
  const ax = e as { response?: { data?: { error?: string } } };
  if (ax.response?.data?.error) return ax.response.data.error;
  if (e instanceof Error && e.message) return e.message;
  return fallback;
}

export async function enviarManifestacao(body: EscutaFormInput): Promise<EscutaPublica> {
  const { data } = await api.post<{ success: boolean; manifestacao: EscutaPublica }>("/api/escuta", body);
  return data.manifestacao;
}

export async function fetchProtocolo(protocolo: string): Promise<EscutaPublica> {
  const { data } = await api.get<{ success: boolean; manifestacao: EscutaPublica }>(
    `/api/escuta/protocolo/${encodeURIComponent(protocolo)}`,
  );
  return data.manifestacao;
}

export function pdfProtocoloUrl(protocolo: string): string {
  return `/api/escuta/protocolo/${encodeURIComponent(protocolo)}/pdf`;
}

export async function fetchEscutaLista(params: {
  q?: string;
  tipo?: string;
  status?: string;
  anonima?: string;
}): Promise<{ resumo: EscutaResumo; manifestacoes: EscutaListaItem[] }> {
  const { data } = await api.get<{ success: boolean; resumo: EscutaResumo; manifestacoes: EscutaListaItem[] }>(
    "/api/gente-gestao/escuta",
    { params },
  );
  return { resumo: data.resumo, manifestacoes: data.manifestacoes };
}

export async function fetchEscutaDetalhe(id: string): Promise<EscutaDetalhe> {
  const { data } = await api.get<{ success: boolean; manifestacao: EscutaDetalhe }>(
    `/api/gente-gestao/escuta/${id}`,
  );
  return data.manifestacao;
}

export async function atualizarEscuta(
  id: string,
  body: { status: string; responsavel: string; notasInternas: string; resposta: string },
): Promise<EscutaDetalhe> {
  const { data } = await api.patch<{ success: boolean; manifestacao: EscutaDetalhe }>(
    `/api/gente-gestao/escuta/${id}`,
    body,
  );
  return data.manifestacao;
}

export function pdfCartazUrl(): string {
  return "/api/gente-gestao/escuta/cartaz.pdf";
}

export function pdfOpiniaoUrl(id: string): string {
  return `/api/gente-gestao/escuta/${id}/pdf`;
}
